<div class="modal-body">
  <alert type="success">
    <h4 class="alert-heading">Adicionado com sucesso</h4>
    <p>Foi adicionado ao carrinho, abaixo mais informações: </p>    
  </alert>
  <div class="table-responsive mb-0">
    <table class="table shoping-cart-table">
      <tbody>
        <tr>      
          <td>
            <h3 class="lead">{{ numeroDocumento }}</h3>
          </td>         
          <td>
            <h3 class="lead"> {{ nivel }}</h3>
          </td>               
          <td>
            <h4 class="lead">
              {{ valorCorrigido | currency:'BRL':'symbol':'1.2' }}
            </h4>
          </td>
        </tr>
      </tbody>
    </table>          
  </div>  

  <hr class="my-2">
  <div class="w-100 text-center">    
    <button type="button" mat-raised-button (click)="onClose()" >Continue comprando</button>
    <button type="button" mat-raised-button (click)="openCart()" class="btn-success">Prosseguir</button>
  </div>
  
</div> 